export default "__VITE_ASSET__dbd8ae0c__"